import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'fr', flag: '🇫🇷', label: 'FR' },
  { code: 'en', flag: '🇬🇧', label: 'EN' },
  { code: 'es', flag: '🇪🇸', label: 'ES' },
  { code: 'de', flag: '🇩🇪', label: 'DE' },
];

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2) ?? 'fr';

  return (
    <div className="flex items-center gap-1" role="group" aria-label="Language">
      {LANGUAGES.map(({ code, flag, label }) => (
        <button
          key={code}
          type="button"
          onClick={() => i18n.changeLanguage(code)}
          aria-pressed={current === code}
          className={[
            'flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-semibold transition-all',
            current === code
              ? 'bg-yellow-400/15 text-yellow-500 border border-yellow-500/35'
              : 'text-muted-foreground border border-transparent hover:text-foreground hover:border-border',
          ].join(' ')}
        >
          <span aria-hidden="true">{flag}</span>
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
